import {
  PAGE_TYPE_ACCOUNT,
  PAGE_TYPE_CART,
  PAGE_TYPE_CHECKOUT,
  PAGE_TYPE_LOGIN,
  TENANT_COM,
} from 'shared/consts'
import store from 'shared/store'

const ERX_MODAL_ID = 'ErxModal'

const blacklistedPages = [
  PAGE_TYPE_ACCOUNT,
  PAGE_TYPE_CART,
  PAGE_TYPE_CHECKOUT,
  PAGE_TYPE_LOGIN,
]

export const triggerErxModal = () => {
  setTimeout(function () {
    window.location.hash = ERX_MODAL_ID
    window.sessionStorage.setItem(ERX_MODAL_ID, 'true')
    window.dataLayer.push({ 'event': 'popin', 'popinName': '__eRxModal' })
  }, 5000)
}

export const isPageBlacklisted = (page: string) =>
  blacklistedPages.includes(page)

export default () => {
  const isErxModalShown = window.sessionStorage.getItem(ERX_MODAL_ID)
  const publicRuntimeConfig = store.getState()?.publicRuntimeConfig
  const { tenant } = publicRuntimeConfig?.publicConfig || {}
  const { pageType = '', coreShopEnvironment } =
    publicRuntimeConfig?.pageProperties || {}

  if (
    isPageBlacklisted(pageType) ||
    isErxModalShown ||
    tenant !== TENANT_COM ||
    coreShopEnvironment === 'qs'
  ) {
    return
  }

  triggerErxModal()
}
